import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { fetchStoreInfo } from '../services/api';

const WhatsAppCTA = () => {
  const { t } = useLanguage();
  const [whatsapp, setWhatsapp] = useState('');

  useEffect(() => {
    fetchStoreInfo().then((s) => setWhatsapp(s.whatsapp || '')).catch(() => {});
  }, []);

  const handleWhatsApp = () => {
    if (!whatsapp) return;
    window.open(`https://wa.me/${whatsapp.replace(/[^0-9]/g, '')}`, '_blank');
  };

  return (
    <section className="py-24 lg:py-32 bg-[#1a1a1a] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23b8860b' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
        <h2 className="text-3xl md:text-4xl font-light text-white mb-6 tracking-wide">
          {t('contact.subtitle')}
        </h2>
        <p className="text-[#bcbbb4] text-base mb-10 max-w-xl mx-auto">
          {t('contact.title')}
        </p>
        <button
          onClick={handleWhatsApp}
          className="inline-flex items-center gap-3 px-10 py-5 bg-[#25d366] text-white text-sm font-medium tracking-widest uppercase transition-all duration-300 hover:bg-[#128c7e]"
        >
          <MessageCircle className="w-5 h-5" />
          {t('contact.whatsapp')}
        </button>
      </div>
    </section>
  );
};

export default WhatsAppCTA;
